/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-30 16:41:43
 * @ Modified by: David Helmick
 * @ Modified time: 2025-08-14 12:19:02
 * @ Description: The filtering options for all pages with properties listed
 */

import React, { useState, useEffect, Fragment, useRef } from 'react'

import Autocomplete from '@mui/material/Autocomplete'
import {
  TextValidator,
  ValidatorForm} from '@/housefolios-components/shared/muiFormValidator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Centralized lodash imports - much cleaner!
import {
  cloneDeep,
  filter,
  isEqual,
  isEmpty,
  sortBy,
  map,
  flatMap,
  toLower,
  difference,
  get,
  remove,
  pullAt,
  isArray,
  includes,
  startCase,
  floor,
  slice,
  merge,
  unset,
  forEach,
  every,
  isNil,
  sum,
  trim,
  debounce,
  uniqBy} from '@/utils/lodash'

import {
  Grid, Box, Button, ButtonGroup, Card, CardContent, CardHeader, Checkbox, Collapse, Container, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, FormLabel,  InputAdornment, MenuItem, Select, TextField, Typography, IconButton, InputLabel } from '@mui/material'
import withSession from '@/housefolios-components/Session/withSession'
import { useMutation } from '@apollo/client/react'
import { UPDATE_ORGANIZATION } from '@/housefolios-components/OrganizationSettings/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { Close, FilterList } from '@mui/icons-material'
import { enqueueSnackbar } from 'notistack'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { INITIAL_FILTERS } from './defaultValues'

import {
  getStrategyName,
  replaceStrategyName} from '@/utils/stratagies'

const PropertiesFilterComponent = (props) => {
  const [accordion, setAccordion] = useState([
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ])
  const [currentFilters, setCurrentFilters] = useState(
    cloneDeep(INITIAL_FILTERS),
  )
  const [activeTab, setActiveTab] = useState('')
  const [activeTab1, setActiveTab1] = useState('')
  const [saveFilter, setSaveFilter] = useState(false)
  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [open, setOpen] = useState(false)
  const [name, setName] = useState('')
  const [activeName, setActiveName] = useState('')
  const [filters, setFilters] = useState(
    props.activeOrg.filters || [],
  )
  const [hasChanged, setHasChanged] = useState(false)
  const [searchStatus, setSearchStatus] = useState(false)
  const [circle, setCircle] = useState(false)

  const [updateOrganization] = useMutation(UPDATE_ORGANIZATION, {
    refetchQueries: [{ query: GET_ME }],
  })

  // Use ref to track previous props for comparison
  const prevPropsRef = useRef()
  const prevStateRef = useRef()

  useEffect(() => {
    let {
      LocationFilters,
      StrategyFilters,
      FavoriteFilters,
      OwnedFilters,
      PropertyFilters,
      MoreDetailFilters,
      StageFilters,
      BuyHoldFinancialFilters,
      FixFlipFinancialFilters,
      TurnkeyFinancialFilters,
      BRRRRFinancialFilters,
      STRFinancialFilters,
      buildToRentFinancialFilters,
      WholesaleFilters,
      BORFinancialFilters,
      AstroFlipFilters,
      AffiliateFilters} = cloneDeep(INITIAL_FILTERS)
    if (props.propertySearch) {
      pullAt(LocationFilters, [2])
      pullAt(PropertyFilters, [1, 2, 3, 4, 10, 11, 12, 13])
    } else if (props.lot) {
      pullAt(PropertyFilters, [3, 4, 9, 10, 11, 13])
    } else if (props.comps) {
      pullAt(LocationFilters, [2, 3])
      pullAt(PropertyFilters, [10, 13])
    } else if (props.public) {
      pullAt(PropertyFilters, [3, 4, 10, 11, 12])
    } else {
      pullAt(PropertyFilters, [3, 4, 11])
    }
    const nextFilters = {
      LocationFilters,
      StrategyFilters,
      FavoriteFilters,
      OwnedFilters,
      PropertyFilters,
      MoreDetailFilters,
      StageFilters,
      BuyHoldFinancialFilters,
      FixFlipFinancialFilters,
      TurnkeyFinancialFilters,
      BRRRRFinancialFilters,
      STRFinancialFilters,
      buildToRentFinancialFilters,
      WholesaleFilters,
      BORFinancialFilters,
      AstroFlipFilters,
      AffiliateFilters}
    setCurrentFilters((prev) =>
      isEqual(prev, nextFilters) ? prev : nextFilters,
    )
  }, [props.propertySearch, props.lot, props.comps, props.public])

  // Apply filters when inputs change — avoid setState when the filtered list is unchanged
  useEffect(() => {
    const prevProps = prevPropsRef.current
    const prevState = prevStateRef.current
    const propertiesKey = (props.properties || [])
      .map((p) => p?._id)
      .join(',')
    const prevPropertiesKey = (prevProps?.properties || [])
      .map((p) => p?._id)
      .join(',')

    if (
      prevProps &&
      (propertiesKey !== prevPropertiesKey ||
        !isFiltersEqual(prevState) ||
        prevProps.search !== props.search)
    ) {
      handleFilters()
    } else if (!prevProps) {
      // First mount after filter shape is ready
      handleFilters()
    }

    // Update refs for next comparison
    prevPropsRef.current = props
    prevStateRef.current = { currentFilters, activeName, hasChanged }
  }, [
    props.properties,
    props.search,
    currentFilters,
    activeName,
    hasChanged,
  ])

  const isFiltersEqual = (prevState) => {
    return isEqual(currentFilters, prevState.currentFilters)
  }

  const reset = () => {
    let {
      LocationFilters,
      StrategyFilters,
      FavoriteFilters,
      OwnedFilters,
      PropertyFilters,
      MoreDetailFilters,
      StageFilters,
      BuyHoldFinancialFilters,
      FixFlipFinancialFilters,
      TurnkeyFinancialFilters,
      BRRRRFinancialFilters,
      STRFinancialFilters,
      buildToRentFinancialFilters,
      WholesaleFilters,
      BORFinancialFilters,
      AstroFlipFilters,
      AffiliateFilters} = cloneDeep(INITIAL_FILTERS)
    if (props.propertySearch) {
      pullAt(LocationFilters, [2])
      //StrategyFilters = []
      pullAt(PropertyFilters, [1, 2, 3, 4, 10, 11, 12, 13])
      // StageFilters = []
      // FinancialFilters = []
    } else if (props.lot) {
      //pullAt(LocationFilters, [2])
      //StrategyFilters = []
      pullAt(PropertyFilters, [3, 4, 9, 10, 11, 13])
      // StageFilters = []
      // FinancialFilters = []
    } else if (props.comps) {
      pullAt(LocationFilters, [2, 3])
      //StrategyFilters = []
      pullAt(PropertyFilters, [9, 10, 13])
      // StageFilters = []
      // FinancialFilters = []
    } else if (props.public) {
      //pullAt(LocationFilters, [])
      //StrategyFilters = []
      pullAt(PropertyFilters, [3, 4, 10, 11, 12])
      // StageFilters = []
      // FinancialFilters = []
    } else {
      //pullAt(LocationFilters, [])
      //StrategyFilters = []
      pullAt(PropertyFilters, [3, 4, 11])
      // StageFilters = []
      // FinancialFilters = []
    }
    setCurrentFilters({
      LocationFilters,
      StrategyFilters,
      FavoriteFilters,
      OwnedFilters,
      PropertyFilters,
      MoreDetailFilters,
      StageFilters,
      BuyHoldFinancialFilters,
      FixFlipFinancialFilters,
      TurnkeyFinancialFilters,
      BRRRRFinancialFilters,
      STRFinancialFilters,
      buildToRentFinancialFilters,
      WholesaleFilters,
      BORFinancialFilters,
      AstroFlipFilters,
      AffiliateFilters,
    })
    setActiveName('')
    setHasChanged(false)
    if (props.propertySearch) props.getSearchResults('')
  }

  const toggleSearch = () => {
    setSearchStatus(!searchStatus)
  }

  const handleFilterClick = (key) => {
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === key)
          filter[i].active = !filter[i].active
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  const handleChangeChip = (name, value) => {
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === name) {
          filter[i].value = value
          filter[i].active = !isEmpty(value)
        }
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  const handleChangeDropdown = (event) => {
    let { name, value } = event.target
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === name) {
          filter[i].value = value
          filter[i].active = !isNil(value)
        }
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  const handleChangeString = (key) => {
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === key)
          filter[i].active = !filter[i].active
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  const handleChangeMin = (event, max) => {
    let { name, value } = event.target
    if (Number(value) > Number(max) && max && value) value = max
    if (!value && name !== 'Beds' && name !== 'Baths') value = null
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === name) {
          filter[i].min = value
          filter[i].active = !isNil(value) || !isNil(filter[i].max)
        }
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  // Debounce the handleChangeMin method
  const debouncedHandleChangeMin = debounce(handleChangeMin, 600) // Adjust 500ms to your needs

  const handleChangeMax = (event, min) => {
    let { name, value } = event.target
    if (Number(value) < Number(min) && min && value) value = min
    if (!value) value = null
    let newFilters = cloneDeep(currentFilters)

    forEach(newFilters, (filter) => {
      for (let i = 0; i < filter.length; i++) {
        if (filter[i].Header === name) {
          filter[i].max = value
          filter[i].active = !isNil(value) || !isNil(filter[i].min)
        }
      }
    })

    setCurrentFilters(newFilters)
    setHasChanged(true)
    //handleFilters()
  }

  // Debounce the handleChangeMin method
  const debouncedHandleChangeMax = debounce(handleChangeMax, 1200) // Adjust 500ms to your needs

  const filterStringChips = (filtered, filters) => {
    const { marketplace, propertySearch, comps, lot } = props
    let anti = filtered
    let diff = filtered
    let check = true
    map(filters, (filter) => {
      if (filter.active && !isEmpty(filter.value)) {
        anti = filtered
        map(filter.value, (value) => {
          check = false
          let target =
            lot && filter.lotTarget
              ? filter.lotTarget
              : comps && filter.compsTarget
                ? filter.compsTarget
                : propertySearch && filter.propertySearchTarget
                  ? filter.propertySearchTarget
                  : marketplace && filter.marketplaceTarget
                    ? filter.marketplaceTarget
                    : filter.target
          anti = anti.filter(
            (property) =>
              isArray(get(property, target))
                ? !includes(trim(get(property, target)), trim(value))
                : trim(toLower(get(property, target))) !==
                  trim(toLower(value)), //arrays are case sensitive
          )
        })
        diff = difference(diff, anti)
      }
    })
    if (check) return filtered
    return diff
  }

  const filterDropdowns = (filtered, filters) => {
    const { marketplace, propertySearch, comps, lot } = props
    map(filters, (filter) => {
      if (filter.active) {
        filtered = filtered.filter((property) => {
          return (
            get(
              property,
              lot && filter.lotTarget
                ? filter.lotTarget
                : comps && filter.compsTarget
                  ? filter.compsTarget
                  : propertySearch && filter.propertySearchTarget
                    ? filter.propertySearchTarget
                    : marketplace && filter.marketplaceTarget
                      ? filter.marketplaceTarget
                      : filter.target,
            ) === filter.value &&
            get(
              property,
              lot && filter.lotTarget
                ? filter.lotTarget
                : comps && filter.compsTarget
                  ? filter.compsTarget
                  : propertySearch && filter.propertySearchTarget
                    ? filter.propertySearchTarget
                    : marketplace && filter.marketplaceTarget
                      ? filter.marketplaceTarget
                      : filter.target,
            ) != null
          )
        })
      }
    })
    return filtered
  }

  const filterMinMax = (filtered, filters) => {
    const { marketplace, propertySearch, comps, lot } = props
    map(filters, (filter) => {
      if (filter.active) {
        //if filter has a parseFunction or is type date than parse then with that. Else parseFloat
        const parse =
          filter.parseFunction && !comps
            ? filter.parseFunction
            : filter.type === 'date'
              ? (date) => new Date(date).getTime()
              : parseFloat
        //parse min/max based on if its a date or not
        const parseMinMax =
          filter.type === 'date'
            ? (date) => new Date(date).getTime()
            : parseFloat
        if (filter.min)
          filtered = filtered.filter((property) => {
            return (
              parse(
                get(
                  property,
                  lot && filter.lotTarget
                    ? filter.lotTarget
                    : comps && filter.compsTarget
                      ? filter.compsTarget
                      : propertySearch && filter.propertySearchTarget
                        ? filter.propertySearchTarget
                        : marketplace && filter.marketplaceTarget
                          ? filter.marketplaceTarget
                          : filter.target,
                ),
              ) >=
                parseMinMax(filter.min) / (filter.divisor || 1) &&
              filter.min &&
              get(
                property,
                lot && filter.lotTarget
                  ? filter.lotTarget
                  : comps && filter.compsTarget
                    ? filter.compsTarget
                    : propertySearch && filter.propertySearchTarget
                      ? filter.propertySearchTarget
                      : marketplace && filter.marketplaceTarget
                        ? filter.marketplaceTarget
                        : filter.target,
              ) != null
            )
          })
        if (filter.max)
          filtered = filtered.filter((property) => {
            return (
              parse(
                get(
                  property,
                  lot && filter.lotTarget
                    ? filter.lotTarget
                    : comps && filter.compsTarget
                      ? filter.compsTarget
                      : propertySearch && filter.propertySearchTarget
                        ? filter.propertySearchTarget
                        : marketplace && filter.marketplaceTarget
                          ? filter.marketplaceTarget
                          : filter.target,
                ),
              ) <=
                parseMinMax(filter.max) / (filter.divisor || 1) &&
              filter.max &&
              get(
                property,
                lot && filter.lotTarget
                  ? filter.lotTarget
                  : comps && filter.compsTarget
                    ? filter.compsTarget
                    : propertySearch && filter.propertySearchTarget
                      ? filter.propertySearchTarget
                      : marketplace && filter.marketplaceTarget
                        ? filter.marketplaceTarget
                        : filter.target,
              ) != null
            )
          })
      }
    })
    return filtered
  }

  const filterOut = (filtered, filters) => {
    const { marketplace, propertySearch, comps, lot } = props
    let anti = filtered
    let check = true
    map(filters, (filter) => {
      if (filter.active) {
        check = false
        //if no value only check if it doesn't exists
        if (filter.value)
          anti = anti.filter(
            (property) =>
              property[
                lot && filter.lotTarget
                  ? filter.lotTarget
                  : comps && filter.compsTarget
                    ? filter.compsTarget
                    : propertySearch && filter.propertySearchTarget
                      ? filter.propertySearchTarget
                      : marketplace && filter.marketplaceTarget
                        ? filter.marketplaceTarget
                        : filter.target
              ] !== filter.value,
          )
        else
          anti = anti.filter(
            (property) =>
              !property[
                lot && filter.lotTarget
                  ? filter.lotTarget
                  : comps && filter.compsTarget
                    ? filter.compsTarget
                    : propertySearch && filter.propertySearchTarget
                      ? filter.propertySearchTarget
                      : marketplace && filter.marketplaceTarget
                        ? filter.marketplaceTarget
                        : filter.target
              ],
          )
      }
    })
    if (check) return filtered
    return difference(filtered, anti)
  }

  const filterOutStage = (filtered, filters) => {
    let anti = filtered
    let check = true
    map(filters, (filter) => {
      if (filter.active) {
        check = false
        if (filter.value !== 'new') {
          if (filter.value === 'needsInfo') {
            anti = anti.filter((property) =>
              props.lot
                ? property?.status
                : property.acquisition.analysis.listPrice > 0 &&
                  (property.acquisition.analysis.afterRepairValue >
                    0 ||
                    property.acquisition.analysis
                      .afterRepairValueBuyHold > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueFixFlip > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueTurnkey > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueSTR > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueB2R > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueBRRRR > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueBOR > 0 ||
                    property.acquisition.analysis
                      .afterRepairValueWholesale > 0) &&
                  property.acquisition.analysis.rent > 0 &&
                  property.acquisition.analysis.resellPrice > 0 &&
                  property.acquisition.analysis.offerPrice > 0,
            )
          } else {
            anti = anti.filter((property) =>
              props.lot
                ? property?.status !== filter.value
                : !property.acquisition ||
                  property.acquisition.activeStage !== filter.value,
            )
          }
        } else {
          anti = anti.filter(
            (property) =>
              props.lot
                ? property?.status
                : property.acquisition &&
                  property.acquisition.activeStage,
            // !(
            //   property.acquisition.analysis.listPrice > 0 &&
            //   property.acquisition.analysis.afterRepairValue > 0 &&
            //   property.acquisition.analysis.rent > 0 &&
            //   property.acquisition.analysis.resellPrice > 0 &&
            //   property.acquisition.analysis.offerPrice > 0
            // ),
          )
        }
      }
    })
    if (check) return filtered
    return difference(filtered, anti)
  }

  const handleFilters = () => {
    const {
      properties,
      getFilteredProperties,
      setFilterReset,
      propertySearch,
      setIsSavedFilter} = props
    let filtered = properties
    let filters = { ...currentFilters }
    const { StageFilters } = filters
    unset(filters, 'StageFilters')
    let activeFilter = false
    if (isEmpty(props.activeOrg.affiliate))
      unset(filters, 'AffiliateFilters')
    forEach(filters, (filters, key) => {
      filtered = filterStringChips(
        filtered,
        filter(filters, ['filterType', 'chip']),
      )
      filtered = filterDropdowns(
        filtered,
        filter(filters, ['filterType', 'dropdown']),
      )
      filtered = filterOut(
        filtered,
        filter(filters, ['filterType', 'checkbox']),
      )
      // filtered = filterOut(filtered, filter(filters, ["filterType", "string"]))
      filtered = filterMinMax(
        filtered,
        filter(filters, ['filterType', 'minmax']),
      )
      if (!every(filters, { active: false  })) activeFilter = true
    })
    filtered = filterOutStage(filtered, StageFilters)
    if (!every(StageFilters, { active: false  })) activeFilter = true
    if (propertySearch && props.search) activeFilter = true
    if (activeFilter) {
      if (props.propertySearch || props.lot || props.comps) {
        setFilterReset((prev) => prev || reset)
      } else if (activeName) {
        setFilterReset((prev) => prev || reset)
        setIsSavedFilter((prev) => (prev === true ? prev : true))
      } else {
        setFilterReset((prev) => prev || toggleModal)
        setIsSavedFilter((prev) => (prev === false ? prev : false))
      }
    } else {
      setFilterReset((prev) => (prev === null ? prev : null))
    }
    getFilteredProperties(filtered)
    // if (propertySearch) {
    //   my_my_lzma.compress(JSON.stringify(filtered), 1, (result, error) => {
    //     const size = new TextEncoder().encode(JSON.stringify(result)).length
    //     if (size < 4 * 1024 * 1024)
    //       localStorage.setItem('propertySearch', result)
    //     else
    //       localStorage.setItem('propertySearch', null)
    //   }, percent => { return  })
    // }
  }

  const renderMinMaxFilters = (data) => {
    if (data.Header === 'Beds' || data.Header === 'Baths')
      return (
        <Fragment key={data.Header}>
          <Grid size={12}
            style={{ marginTop: 15 }}
          >
            <Typography style={{ textAlign: 'left' }}>
              {replaceStrategyName(
                data.Header,
                props?.session?.me?.activeOrg?.member,
              )}
            </Typography>
          </Grid>
          <Grid size={12} key={`${data.Header} field`}>
            <ButtonGroup data-hf="filter-minmax">
              {map(data.options, (option) => (
                <Button
                  key={option}
                  data-hf-selected={data.min === option ? '' : undefined}
                  sx={(theme) => {
                    const selected = data.min === option
                    const isDark = theme.palette.mode === 'dark'
                    return {
                      color: selected
                        ? '#fff'
                        : isDark
                          ? 'rgba(255, 255, 255, 0.85)'
                          : 'rgba(0, 0, 0, 0.87)',
                      borderColor: isDark
                        ? 'rgba(255, 255, 255, 0.28)'
                        : 'rgba(0, 0, 0, 0.2)',
                      backgroundColor:
                        !selected && isDark
                          ? 'rgba(255, 255, 255, 0.06)'
                          : undefined,
                    }
                  }}
                  onClick={(event) =>
                    handleChangeMin(
                      {
                        target: {
                          name: data.Header,
                          value: data.min === option ? null : option}},
                      data.max,
                    )
                  }
                >
                  {option}+
                </Button>
              ))}
            </ButtonGroup>
          </Grid>
        </Fragment>
      )
    else if (data.type === 'date')
      return (
        <Fragment key={data.Header}>
          <Grid size={12}>
            <Typography style={{ textAlign: 'left' }}>
              {replaceStrategyName(
                data.Header,
                props?.session?.me?.activeOrg?.member,
              )}
            </Typography>
          </Grid>
          <Grid size={12} key={`${data.Header} field`}>
            <Grid
              container
              direction="row"
              wrap="nowrap"
              sx={{
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Grid size={5} key={`${data.Header} first`}>
                <FormControl fullWidth variant="outlined">
                  {/* <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel> */}

                  <DatePicker
                    name={data.Header}
                    disableFuture={
                      data.Header === 'Yr Built' ? true : false
                    }
                    value={data.min}
                    onChange={(date) =>
                      debouncedHandleChangeMin(
                        {
                          target: {
                            name: data.Header,
                            value: date,
                            type: 'date'}},
                        data.max,
                      )
                    }
                    format="MM/dd/yyyy"
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        margin: 'dense',
                        fullWidth: true,
                        style: { borderColor: 'grey' },
                        placeholder: replaceStrategyName(
                          data.Header,
                          props?.session?.me?.activeOrg?.member,
                        ),
                        slotProps: {
                          inputLabel: { shrink: true },
                        },
                      },
                    }}
                    views={
                      data?.dateViews
                        ? data.dateViews
                        : ['year', 'month', 'day']
                    }
                    openTo={data?.view ? data?.view : 'month'}
                  />
                </FormControl>
              </Grid>
              <Grid size={1} key={`${data.Header} to`}>
                <Typography>to</Typography>
              </Grid>
              <Grid size={5} key={`${data.Header} last`}>
                <FormControl fullWidth variant="outlined">
                  {/* <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel> */}

                  <DatePicker
                    name={data.Header}
                    disableFuture={
                      data.Header === 'Yr Built' ? true : false
                    }
                    value={data.max}
                    onChange={(date) =>
                      debouncedHandleChangeMax(
                        {
                          target: {
                            name: data.Header,
                            value: date,
                            type: 'date'}},
                        data.min,
                      )
                    }
                    format="MM/dd/yyyy"
                    slotProps={{
                      textField: {
                        variant: 'outlined',
                        margin: 'dense',
                        fullWidth: true,
                        style: { borderColor: 'grey' },
                        placeholder: replaceStrategyName(
                          data.Header,
                          props?.session?.me?.activeOrg?.member,
                        ),
                        slotProps: {
                          inputLabel: { shrink: true },
                        },
                      },
                    }}
                    views={
                      data?.dateViews
                        ? data.dateViews
                        : ['year', 'month', 'day']
                    }
                    openTo={data?.view ? data?.view : 'month'}
                    shouldDisableYear={
                      data.Header === 'Yr Built'
                        ? (year) => year?.getFullYear() < data?.min
                        : (year) => false
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Fragment>
      );
    return (
      <Fragment key={data.Header}>
        <Grid size={12}>
          <Typography style={{ textAlign: 'left' }}>
            {replaceStrategyName(
              data.Header,
              props?.session?.me?.activeOrg?.member,
            )}
          </Typography>
        </Grid>
        <Grid size={12} key={`${data.Header} field`}>
          <Grid
            container
            direction="row"
            wrap="nowrap"
            sx={{
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Grid size={5} key={`${data.Header} first`}>
              <FormControl fullWidth variant="outlined">
                {/* <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel> */}
                <Select
                  //labelId="demo-simple-select-outlined-label"
                  name={data.Header}
                  id="demo-simple-select-outlined"
                  value={data.min || ''}
                  onChange={(event) =>
                    handleChangeMin(event, data.max)
                  }
                  size="small"
                  displayEmpty
                >
                  <MenuItem key="blank" value={''}>
                    <em>No Min</em>
                  </MenuItem>
                  {map(
                    filter(data.options, (option) => {
                      return option <= data.max || !data.max
                    }),
                    (option) => (
                      <MenuItem key={option} value={option}>
                        {data.formatOption
                          ? data.formatOption(option)
                          : option}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid size={1} key={`${data.Header} to`}>
              <Typography>to</Typography>
            </Grid>
            <Grid size={5} key={`${data.Header} last`}>
              <FormControl fullWidth variant="outlined">
                {/* <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel> */}
                <Select
                  //labelId="demo-simple-select-outlined-label"
                  name={data.Header}
                  id="demo-simple-select-outlined"
                  value={data.max || ''}
                  onChange={(event) =>
                    handleChangeMax(event, data.min)
                  }
                  size="small"
                  displayEmpty
                >
                  <MenuItem key="blank" value={''}>
                    <em>No Max</em>
                  </MenuItem>
                  {map(
                    filter(data.options, (option) => {
                      return option >= data.min || !data.min
                    }),
                    (option) => (
                      <MenuItem key={option} value={option}>
                        {data.formatOption
                          ? data.formatOption(option)
                          : option}
                      </MenuItem>
                    ),
                  )}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  const renderStringChipFilters = (data) => {
    const { properties } = props
    let options = filter(
      uniqBy(
        sortBy(
          flatMap(properties, (property) => {
            return isArray(get(property, data.target))
              ? map(get(property, data.target))
              : get(property, data.target)
          }),
        ),
        toLower,
      ),
      (value) => value !== 'null' && value,
    )
    if (
      data.target !== 'state' &&
      data.target !== 'zip' &&
      data.target !== 'marketplaces.approvedMarketplace' &&
      data.target !== 'createdBy.email' &&
      data.target !== 'propertyType'
    )
      options = map(options, (option) => startCase(toLower(option)))
    return (
      <Grid key={`${data.Header} field`}>
        <Autocomplete
          multiple
          //id="fixed-tags-demo"
          options={options}
          disableCloseOnSelect
          value={data.value}
          onChange={(event, value) =>
            handleChangeChip(data.Header, value)
          }
          renderValue={(value, getItemProps) =>
            value.map((option, index) => (
              <Chip
                color="primary"
                key={index}
                label={option}
                {...getItemProps({ index })}
                //disabled={index === 0}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              margin="dense"
              label={replaceStrategyName(
                data.Header,
                props?.session?.me?.activeOrg?.member,
              )}
              fullWidth
            />
          )}
        />
      </Grid>
    );
  }

  const renderCheckboxFilters = (filter) => (
    <Grid size={filter.xs}
      key={`${filter.Header} field`}
      style={{ textAlign: 'left' }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={filter.active}
            onChange={() => handleFilterClick(filter.Header)}
            value={filter.Header}
          />
        }
        label={
          props.lot && filter.lotHeader
            ? filter.lotHeader
            : filter.target === 'strategy'
              ? getStrategyName(
                  filter.Header,
                  props?.session?.me?.activeOrg?.member,
                )
              : filter.Header
        }
      />
    </Grid>
  )

  const renderDropdownFilters = (data) => {
    return (
      <Grid key={`${data.Header} field`}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>
            {replaceStrategyName(
              data.Header,
              props?.session?.me?.activeOrg?.member,
            )}
          </InputLabel>
          <Select
            name={data.Header}
            value={data.value}
            label={replaceStrategyName(
              data.Header,
              props?.session?.me?.activeOrg?.member,
            )}
            onChange={(event) => handleChangeDropdown(event)}
          >
            {map(data.options, (option) => (
              <MenuItem key={option} value={option}>
                {data.formatOption ? data.formatOption(option) : option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    )
  }

  const renderFilters = (filter) => {
    if (filter.filterType === 'chip')
      return renderStringChipFilters(filter)
    if (filter.filterType === 'dropdown')
      return renderDropdownFilters(filter)
    // else if (filter.filterType === 'string')
    //   return renderStringFilters(filter)
    else if (filter.filterType === 'minmax')
      return renderMinMaxFilters(filter)
    else if (filter.filterType === 'checkbox')
      return renderCheckboxFilters(filter)
  }

  const removeTypename = (obj) => {
    for (var prop in obj) {
      if (prop === '__typename') delete obj[prop]
      else if (typeof obj[prop] === 'object')
        removeTypename(obj[prop])
    }
  }

  const selectFilter = (event, value, reason) => {
    // MUI Autocomplete fires reason "reset" when the controlled value is
    // reconciled — must NOT treat that as a user clear or we loop forever.
    if (reason === 'clear') {
      reset()
      return
    }
    if (value) {
      setCurrentFilters(
        merge(cloneDeep(currentFilters), value.currentFilters),
      )
      setActiveName(value.name)
    }
  }

  const deleteFilter = (filter, filters) => {
    let newFilters = filters
    remove(newFilters, (newFilter) => {
      return newFilter.name === filter
    })
    map(newFilters, removeTypename)
    updateOrganization({
      variables: {
        id: props.activeOrg._id,
        organizationInput: { filters: newFilters },
      },
    })
      .then(() => {
        enqueueSnackbar('Filter was deleted', {
          variant: 'success',
          action: (key) => (
            <Fragment>
              <IconButton
                onClick={() => {
                  props.closeSnackbar(key)
                }}
                size="large"
              >
                <Close style={{ color: 'white' }} />
              </IconButton>
            </Fragment>
          ),
        })
        setActiveName('')
        setShow1(false)
        reset()
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: 'error',
          action: (key) => (
            <Fragment>
              <IconButton
                onClick={() => {
                  props.closeSnackbar(key)
                }}
                size="large"
              >
                <Close style={{ color: 'white' }} />
              </IconButton>
            </Fragment>
          ),
        })
        setActiveName('')
        setShow1(false)
        reset()
      })
  }

  const onSubmit = (event, filters) => {
    setCircle(true)
    let newFilters = cloneDeep(filters)
    let newCurrentFilters = { ...currentFilters }
    forEach(currentFilters, (filters, key) => {
      newCurrentFilters[key] = map(filters, (filter) => {
        return filter.filterType === 'minmax'
          ? {
              Header: filter.Header,
              active: filter.active,
              min: filter.min,
              max: filter.max}
          : {
              Header: filter.Header,
              active: filter.active,
              value: filter.value}
      })
    })
    const newFilter = {
      name,
      currentFilters: newCurrentFilters}
    if (newFilter) newFilters.push(newFilter)
    map(newFilters, removeTypename)
    setName('')
    updateOrganization({
      variables: {
        id: props.activeOrg._id,
        organizationInput: { filters: newFilters },
      },
    })
      .then(async ({ data  }) => {
        enqueueSnackbar('Filter was saved', {
          variant: 'success',
          action: (key) => (
            <Fragment>
              <IconButton
                onClick={() => {
                  props.closeSnackbar(key)
                }}
                size="large"
              >
                <Close style={{ color: 'white' }} />
              </IconButton>
            </Fragment>
          ),
        })
        setShow(false)
        setName('')
        setActiveName(name)
        setHasChanged(false)
        props.setIsSavedFilter(true)
      })
      .catch(async (error) => {
        enqueueSnackbar(error.message, {
          variant: 'error',
          action: (key) => (
            <Fragment>
              <IconButton
                onClick={() => {
                  props.closeSnackbar(key)
                }}
                size="large"
              >
                <Close style={{ color: 'white' }} />
              </IconButton>
            </Fragment>
          ),
        })
        setCircle(false)
        setShow(false)
        setName('')
        setActiveName(name)
      })
  }

  const toggleModal = () => {
    setShow(!show)
  }
  const toggleModal1 = () => {
    setShow1(!show1)
  }
  const toggleSnackbar = () => {
    setOpen(!open)
  }

  const toggleAccordion = (tab) => {
    const newAccordion = accordion.map((x, index) =>
      tab === index ? !x : false,
    )
    setAccordion(newAccordion)
  }

  const toggleActiveTab = (highlight) => {
    setActiveTab(highlight)
  }
  const toggleActiveTab1 = (highlight) => {
    setActiveTab1(highlight)
  }

  // handleChange3 = event => {
  //   const { name = '' } = event.target
  //   setState({ name  })
  // }

  // renderInput = (field, error) => {
  //   return (
  //     <div>

  //     </div>
  //   )efe
  // }

  const {
    LocationFilters,
    StrategyFilters,
    FavoriteFilters,
    OwnedFilters,
    PropertyFilters,
    MoreDetailFilters,
    StageFilters,
    BuyHoldFinancialFilters,
    FixFlipFinancialFilters,
    TurnkeyFinancialFilters,
    BRRRRFinancialFilters,
    STRFinancialFilters,
    buildToRentFinancialFilters,
    WholesaleFilters,
    BORFinancialFilters,
    AstroFlipFilters,
    AffiliateFilters} = currentFilters

  return (
    <>
      <Box sx={[{
        "& > .MuiPaper-root": {
          overflow: "hidden",
          boxShadow: "none !important",
          borderRadius: 0,
          "&:first-of-type": { borderTopLeftRadius: "0.65rem", borderTopRightRadius: "0.65rem" },
          "&:last-of-type": { borderBottomLeftRadius: "0.65rem", borderBottomRightRadius: "0.65rem" },
          "&:not(:last-of-type)": { borderBottom: 0 },
          "& > .MuiPaper-root": { boxShadow: "none !important", borderRadius: "inherit" },
        },
        "& .panel-title, & .accordion-toggle, & [data-hf=\"panel-title\"], & [data-hf=\"accordion-toggle\"]": { width: "100%", display: "block" },
        "& .MuiCard-root > div:has(> .panel-title), & .MuiCard-root > div:has(> [data-hf=\"panel-title\"])": {
          display: "block !important",
          padding: "0 !important",
          width: "100%",
          backgroundColor: "transparent !important",
        },
        "& > .card": {
          overflow: "hidden",
          "&:not(:last-of-type)": { borderBottom: 0, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 },
          "&:not(:first-of-type)": { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
          "& > .card-header": { borderRadius: 0, marginBottom: 0 },
        },
      }, { marginBottom: "48px" }]}>
        <Card variant="outlined" sx={(accordion[0]) && {
          "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
            borderBottomColor: "rgba(79, 80, 98, 0.3)",
            background: "#fff",
            color: "#070919 !important",
            "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
          },
          "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
        }}>
          <div style={{ padding: "1.5rem" }}>
            <Grid
              container
              direction="row"
              spacing={1}
              sx={{
                justifyContent: "center"
              }}
            >
              <Grid size={12} key="Header">
                <Typography variant="h6" sx={{ ml: '5px' }}>
                  Property Filter
                </Typography>
              </Grid>
              {!props.lot &&
                !props.propertySearch &&
                !props.comps && (
                  <Grid size={12} key="Saved Filters">
                    <Autocomplete
                      id="combo-box-demo"
                      value={
                        filters.find((f) => f.name === activeName) ||
                        null
                      }
                      options={filters}
                      noOptionsText="No saved filters yet"
                      getOptionLabel={(option) =>
                        option.name ? option.name : option
                      }
                      isOptionEqualToValue={(option, value) => {
                        if (!option || !value) return option === value
                        return option.name === value.name
                      }}
                      onChange={selectFilter}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Saved Filter"
                          variant="outlined"
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </Grid>
                )}
            </Grid>
          </div>
          <Divider />
          {props.propertySearch && (
            <div style={{ margin: 20 }}>
              <TextField
                variant="outlined"
                size="small"
                sx={[{ backgroundColor: "#fff", "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important" } }, { width: "100%" }]}
                value={props.search}
                onChange={(event) =>
                  props.getSearchResults(event.target.value)
                }
                placeholder={
                  props.propertySearch
                    ? 'Search these properties'
                    : props.marketplace
                      ? 'Search this marketplace'
                      : 'Search this portfolio...'
                }
                id="input-with-icon-textfield22-3"
                label={props.propertySearch && props.searchName}
                onFocus={toggleSearch}
                onBlur={toggleSearch}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <FilterList style={{ color: '#bbbbbb' }} />
                      </InputAdornment>
                    )}
                }}
              />
            </div>
          )}
          <Card>
            <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
              <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                <Box data-hf="accordion-toggle" sx={{
                  "& .MuiButton-root": {
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "left",
                    fontWeight: 700,
                    color: "#3b3e66 !important",
                    textDecoration: "none !important",
                    textTransform: "none",
                    borderRadius: 0,
                    padding: "0.75rem 1.25rem !important",
                    borderBottom: "1px solid transparent",
                    background: "#f4f5fd",
                    "&:hover": {
                      background: "#f8f9ff !important",
                      color: "#070919 !important",
                      textDecoration: "none !important",
                      "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                    },
                    "&:not(:disabled):hover": { transform: "translateY(0px)" },
                    "& [data-hf=\"accordion-icon\"]": {
                      transform: "rotate(90deg)",
                      transition: "all 0.2s ease-in-out",
                      marginLeft: "auto",
                      color: "#368cff !important",
                      overflow: "visible",
                    },
                  },
                  "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                    background: "#2a2a2a !important",
                    color: "rgba(255, 255, 255, 0.9) !important",
                    "&:hover": { background: "#333 !important", color: "#fff !important" },
                  },
                }}>
                  <Button
                    variant="text"
                    size="large"
                    sx={{
                      fontWeight: 700,
                      color: "#3b3e66",
                      textDecoration: "none",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#4191ff",
                        textDecoration: "underline",
                        transform: "translateY(0px)",
                      },
                      "&:active": { textDecoration: "underline", boxShadow: "none" },
                      "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                      "& span": {
                        position: "relative",
                        "&::before": {
                          content: "\"\"",
                          position: "absolute",
                          width: "100%",
                          height: 2,
                          bottom: 0,
                          left: 0,
                          visibility: "hidden",
                          transform: "scaleX(0)",
                          transition: "all 0.3s ease-in-out 0s",
                        },
                        transition: "all 0.2s ease-in-out",
                      },
                      "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                      "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    onClick={() => toggleAccordion(0)}
                    aria-expanded={accordion[0]}
                  >
                    <span>Property Details</span>
                    <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                  </Button>
                </Box>
              </Box>
            </div>
            <Collapse in={accordion[0]}>
              <div style={{ padding: "1.5rem" }}>
                <Grid container direction="column" spacing={1}>
                  {map(PropertyFilters, (filter) =>
                    renderFilters(filter),
                  )}
                </Grid>
              </div>
            </Collapse>
          </Card>
        </Card>
        <Card variant="outlined" sx={(accordion[1]) && {
          "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
            borderBottomColor: "rgba(79, 80, 98, 0.3)",
            background: "#fff",
            color: "#070919 !important",
            "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
          },
          "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
        }}>
          <Card>
            <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
              <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                <Box data-hf="accordion-toggle" sx={{
                  "& .MuiButton-root": {
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textAlign: "left",
                    fontWeight: 700,
                    color: "#3b3e66 !important",
                    textDecoration: "none !important",
                    textTransform: "none",
                    borderRadius: 0,
                    padding: "0.75rem 1.25rem !important",
                    borderBottom: "1px solid transparent",
                    background: "#f4f5fd",
                    "&:hover": {
                      background: "#f8f9ff !important",
                      color: "#070919 !important",
                      textDecoration: "none !important",
                      "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                    },
                    "&:not(:disabled):hover": { transform: "translateY(0px)" },
                    "& [data-hf=\"accordion-icon\"]": {
                      transform: "rotate(90deg)",
                      transition: "all 0.2s ease-in-out",
                      marginLeft: "auto",
                      color: "#368cff !important",
                      overflow: "visible",
                    },
                  },
                  "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                    background: "#2a2a2a !important",
                    color: "rgba(255, 255, 255, 0.9) !important",
                    "&:hover": { background: "#333 !important", color: "#fff !important" },
                  },
                }}>
                  <Button
                    variant="text"
                    size="large"
                    sx={{
                      fontWeight: 700,
                      color: "#3b3e66",
                      textDecoration: "none",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#4191ff",
                        textDecoration: "underline",
                        transform: "translateY(0px)",
                      },
                      "&:active": { textDecoration: "underline", boxShadow: "none" },
                      "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                      "& span": {
                        position: "relative",
                        "&::before": {
                          content: "\"\"",
                          position: "absolute",
                          width: "100%",
                          height: 2,
                          bottom: 0,
                          left: 0,
                          visibility: "hidden",
                          transform: "scaleX(0)",
                          transition: "all 0.3s ease-in-out 0s",
                        },
                        transition: "all 0.2s ease-in-out",
                      },
                      "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                      "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                      "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                    onClick={() => toggleAccordion(1)}
                    aria-expanded={accordion[1]}
                  >
                    <span>Location</span>
                    <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                  </Button>
                </Box>
              </Box>
            </div>
            <Collapse in={accordion[1]}>
              <div style={{ padding: "1.5rem" }}>
                <Container>
                  <Grid
                    container
                    direction="column"
                    spacing={1}
                    sx={{
                      justifyContent: "center"
                    }}
                  >
                    {map(LocationFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </Container>
              </div>
            </Collapse>
          </Card>
        </Card>
        {!props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[2]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(2)}
                      aria-expanded={accordion[2]}
                    >
                      <span>Status</span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[2]}>
                <div style={{ padding: "1.5rem" }}>
                  <FormControl component="fieldset" sx={{ pr: "1.5rem" }}>
                    <FormLabel
                      component="legend"
                      style={{ textAlign: 'left' }}
                    >
                      Availability
                    </FormLabel>
                    <FormGroup>
                      <Grid container>
                        {map(
                          filter(StageFilters, ['avalibility', true]),
                          (filter) => renderFilters(filter),
                        )}
                      </Grid>
                    </FormGroup>
                  </FormControl>
                  <FormControl
                    component="fieldset"
                    style={{ marginTop: 20 }}
                    sx={{ pr: "1.5rem" }}
                  >
                    <FormLabel
                      component="legend"
                      style={{ textAlign: 'left' }}
                    >
                      Stage
                    </FormLabel>
                    <FormGroup>
                      <Grid container>
                        {map(
                          filter(StageFilters, [
                            'avalibility',
                            false,
                          ]),
                          (filter) => renderFilters(filter),
                        )}
                      </Grid>
                    </FormGroup>
                  </FormControl>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[3]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(3)}
                      aria-expanded={accordion[3]}
                    >
                      <span>Strategy</span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[3]}>
                <div style={{ padding: "1.5rem" }}>
                  <FormControl component="fieldset" sx={{ pr: "1.5rem" }}>
                    <FormGroup>
                      <Grid container direction="row">
                        {map(StrategyFilters, (filter) =>
                          renderFilters(filter),
                        )}
                      </Grid>
                    </FormGroup>
                  </FormControl>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot &&
          !props.propertySearch &&
          !props.comps &&
          !props.public && (
            <Card variant="outlined" sx={(accordion[4]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(4)}
                        aria-expanded={accordion[4]}
                      >
                        <span>Favorite</span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[4]}>
                  <div style={{ padding: "1.5rem" }}>
                    <FormControl
                      component="fieldset"
                      sx={{ pr: "1.5rem" }}
                    >
                      <FormGroup>
                        <Grid container direction="row">
                          {map(FavoriteFilters, (filter) =>
                            renderFilters(filter),
                          )}
                        </Grid>
                      </FormGroup>
                    </FormControl>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        {!props.propertySearch && !props.comps && !props.public && (
          <Card variant="outlined" sx={(accordion[5]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(5)}
                      aria-expanded={accordion[5]}
                    >
                      <span>Owned</span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[5]}>
                <div style={{ padding: "1.5rem" }}>
                  <FormControl component="fieldset" sx={{ pr: "1.5rem" }}>
                    <FormGroup>
                      <Grid container>
                        {map(OwnedFilters, (filter) =>
                          renderFilters(filter),
                        )}
                      </Grid>
                    </FormGroup>
                  </FormControl>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[6]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(6)}
                      aria-expanded={accordion[6]}
                    >
                      <span>
                        {getStrategyName(
                          'Buy & Hold',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[6]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {map(BuyHoldFinancialFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[7]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(7)}
                      aria-expanded={accordion[7]}
                    >
                      <span>
                        {getStrategyName(
                          'Fix & Flip',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[7]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {map(FixFlipFinancialFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[8]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(8)}
                      aria-expanded={accordion[8]}
                    >
                      <span>
                        {getStrategyName(
                          'Turnkey',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[8]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {/* <Grid size={12}>
                      <Typography variant='h6' style={{ marginBottom: 10, color: '#04a3e2' }}>Turnkey Operators</Typography>
                    </Grid>
                    {map(slice(TurnkeyFinancialFilters, 4), filter => (
                      renderFilters(filter)
                    ))}
                  <Divider style={{ marginTop: 25, marginBottom: 20 }} /> */}
                    <Grid size={12} key="Header">
                      <Typography
                        variant="h6"
                        style={{
                          marginBottom: 10,
                          color: '#04a3e2'}}
                      >
                        End Buyer
                      </Typography>
                    </Grid>
                    {map(
                      slice(
                        TurnkeyFinancialFilters,
                        4,
                        TurnkeyFinancialFilters.length,
                      ),
                      (filter) => renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[9]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(9)}
                      aria-expanded={accordion[9]}
                    >
                      <span>
                        {getStrategyName(
                          'BRRRR',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[9]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {map(BRRRRFinancialFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[10]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(10)}
                      aria-expanded={accordion[10]}
                    >
                      <span>
                        {getStrategyName(
                          'Short Term Rental',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[10]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {map(STRFinancialFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot && !props.propertySearch && !props.comps && (
          <Card variant="outlined" sx={(accordion[11]) && {
            "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
              borderBottomColor: "rgba(79, 80, 98, 0.3)",
              background: "#fff",
              color: "#070919 !important",
              "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
            },
            "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
          }}>
            <Card>
              <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                  <Box data-hf="accordion-toggle" sx={{
                    "& .MuiButton-root": {
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                      alignItems: "center",
                      textAlign: "left",
                      fontWeight: 700,
                      color: "#3b3e66 !important",
                      textDecoration: "none !important",
                      textTransform: "none",
                      borderRadius: 0,
                      padding: "0.75rem 1.25rem !important",
                      borderBottom: "1px solid transparent",
                      background: "#f4f5fd",
                      "&:hover": {
                        background: "#f8f9ff !important",
                        color: "#070919 !important",
                        textDecoration: "none !important",
                        "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                      },
                      "&:not(:disabled):hover": { transform: "translateY(0px)" },
                      "& [data-hf=\"accordion-icon\"]": {
                        transform: "rotate(90deg)",
                        transition: "all 0.2s ease-in-out",
                        marginLeft: "auto",
                        color: "#368cff !important",
                        overflow: "visible",
                      },
                    },
                    "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                      background: "#2a2a2a !important",
                      color: "rgba(255, 255, 255, 0.9) !important",
                      "&:hover": { background: "#333 !important", color: "#fff !important" },
                    },
                  }}>
                    <Button
                      variant="text"
                      size="large"
                      sx={{
                        fontWeight: 700,
                        color: "#3b3e66",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: "#4191ff",
                          textDecoration: "underline",
                          transform: "translateY(0px)",
                        },
                        "&:active": { textDecoration: "underline", boxShadow: "none" },
                        "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                        "& span": {
                          position: "relative",
                          "&::before": {
                            content: "\"\"",
                            position: "absolute",
                            width: "100%",
                            height: 2,
                            bottom: 0,
                            left: 0,
                            visibility: "hidden",
                            transform: "scaleX(0)",
                            transition: "all 0.3s ease-in-out 0s",
                          },
                          transition: "all 0.2s ease-in-out",
                        },
                        "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                        "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                        "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                      onClick={() => toggleAccordion(11)}
                      aria-expanded={accordion[11]}
                    >
                      <span>
                        {getStrategyName(
                          'Build to Rent',
                          props?.session?.me?.activeOrg?.member,
                        )}{' '}
                        Financials
                      </span>
                      <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                    </Button>
                  </Box>
                </Box>
              </div>
              <Collapse in={accordion[11]}>
                <div style={{ padding: "1.5rem" }}>
                  <Grid container direction="column" spacing={1}>
                    {map(buildToRentFinancialFilters, (filter) =>
                      renderFilters(filter),
                    )}
                  </Grid>
                </div>
              </Collapse>
            </Card>
          </Card>
        )}
        {!props.lot &&
          !props.propertySearch &&
          !props.comps &&
          props?.session?.me?.activeOrg?.member !== 'astroflip' && (
            <Card variant="outlined" sx={(accordion[12]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(12)}
                        aria-expanded={accordion[12]}
                      >
                        <span>
                          {getStrategyName(
                            'Wholesale',
                            props?.session?.me?.activeOrg?.member,
                          )}{' '}
                          Financials
                        </span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[12]}>
                  <div style={{ padding: "1.5rem" }}>
                    <Grid container direction="column" spacing={1}>
                      {map(WholesaleFilters, (filter) =>
                        renderFilters(filter),
                      )}
                    </Grid>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        {!props.lot &&
          !props.propertySearch &&
          !props.comps &&
          props?.session?.me?.activeOrg?.member ===
            'flippingamerica' && (
            <Card variant="outlined" sx={(accordion[13]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(13)}
                        aria-expanded={accordion[13]}
                      >
                        <span>
                          {getStrategyName(
                            'BOR',
                            props?.session?.me?.activeOrg?.member,
                          )}{' '}
                          Financials
                        </span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[13]}>
                  <div style={{ padding: "1.5rem" }}>
                    <Grid container direction="column" spacing={1}>
                      {map(BORFinancialFilters, (filter) =>
                        renderFilters(filter),
                      )}
                    </Grid>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        {!props.lot &&
          !props.propertySearch &&
          !props.comps &&
          props?.session?.me?.activeOrg?.member === 'astroflip' && (
            <Card variant="outlined" sx={(accordion[14]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(14)}
                        aria-expanded={accordion[14]}
                      >
                        <span>
                          {getStrategyName(
                            'Astroflip',
                            props?.session?.me?.activeOrg?.member,
                          )}{' '}
                          Financials
                        </span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[14]}>
                  <div style={{ padding: "1.5rem" }}>
                    <Grid container direction="column" spacing={1}>
                      {map(AstroFlipFilters, (filter) =>
                        renderFilters(filter),
                      )}
                    </Grid>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        {!props.lot &&
          !props.propertySearch &&
          !props.comps &&
          !props.marketplace &&
          !isEmpty(props.activeOrg.affiliate) && (
            <Card variant="outlined" sx={(accordion[15]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(15)}
                        aria-expanded={accordion[15]}
                      >
                        <span>Affiliate</span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[15]}>
                  <div style={{ padding: "1.5rem" }}>
                    <Container>
                      <Grid
                        container
                        direction="column"
                        spacing={1}
                        sx={{
                          justifyContent: "center"
                        }}
                      >
                        {map(AffiliateFilters, (filter) =>
                          renderFilters(filter),
                        )}
                      </Grid>
                    </Container>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        {/* I BELIEVE THIS IS UNUSED CODE NOW SINCE WE USE REALEFLOW */}
        {props.propertySearch &&
          props.session.me.activeOrg.isRealeflow && (
            <Card variant="outlined" sx={(accordion[16]) && {
              "& [data-hf=\"accordion-toggle\"] .MuiButton-root": {
                borderBottomColor: "rgba(79, 80, 98, 0.3)",
                background: "#fff",
                color: "#070919 !important",
                "& [data-hf=\"accordion-icon\"]": { transform: "rotate(180deg)", color: "#368cff !important" },
              },
              "html[data-color-mode=\"dark\"] & [data-hf=\"accordion-toggle\"] .MuiButton-root": { borderBottomColor: "rgba(255, 255, 255, 0.12) !important", background: "#252525 !important", color: "rgba(255, 255, 255, 0.95) !important" },
            }}>
              <Card>
                <div style={{ display: "flex", alignItems: "center", paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "1.25rem", paddingRight: "1.25rem", marginBottom: 0, backgroundColor: "#fff" }}>
                  <Box data-hf="panel-title" sx={{ width: "100%", display: "block" }}>
                    <Box data-hf="accordion-toggle" sx={{
                      "& .MuiButton-root": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        textAlign: "left",
                        fontWeight: 700,
                        color: "#3b3e66 !important",
                        textDecoration: "none !important",
                        textTransform: "none",
                        borderRadius: 0,
                        padding: "0.75rem 1.25rem !important",
                        borderBottom: "1px solid transparent",
                        background: "#f4f5fd",
                        "&:hover": {
                          background: "#f8f9ff !important",
                          color: "#070919 !important",
                          textDecoration: "none !important",
                          "& [data-hf=\"accordion-icon\"]": { color: "#368cff !important" },
                        },
                        "&:not(:disabled):hover": { transform: "translateY(0px)" },
                        "& [data-hf=\"accordion-icon\"]": {
                          transform: "rotate(90deg)",
                          transition: "all 0.2s ease-in-out",
                          marginLeft: "auto",
                          color: "#368cff !important",
                          overflow: "visible",
                        },
                      },
                      "html[data-color-mode=\"dark\"] & .MuiButton-root": {
                        background: "#2a2a2a !important",
                        color: "rgba(255, 255, 255, 0.9) !important",
                        "&:hover": { background: "#333 !important", color: "#fff !important" },
                      },
                    }}>
                      <Button
                        variant="text"
                        size="large"
                        sx={{
                          fontWeight: 700,
                          color: "#3b3e66",
                          textDecoration: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#4191ff",
                            textDecoration: "underline",
                            transform: "translateY(0px)",
                          },
                          "&:active": { textDecoration: "underline", boxShadow: "none" },
                          "&:disabled": { color: "#7a7b97", pointerEvents: "none" },
                          "& span": {
                            position: "relative",
                            "&::before": {
                              content: "\"\"",
                              position: "absolute",
                              width: "100%",
                              height: 2,
                              bottom: 0,
                              left: 0,
                              visibility: "hidden",
                              transform: "scaleX(0)",
                              transition: "all 0.3s ease-in-out 0s",
                            },
                            transition: "all 0.2s ease-in-out",
                          },
                          "&:hover span::before": { visibility: "visible", transform: "scaleX(1)" },
                          "&:disabled, &.disabled": { color: "#d1d2db", pointerEvents: "none" },
                          "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.95) !important", background: "#252525 !important", borderBottomColor: "rgba(255, 255, 255, 0.12) !important" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                        onClick={() => toggleAccordion(16)}
                        aria-expanded={accordion[16]}
                      >
                        <span>More Details</span>
                        <FontAwesomeIcon icon={['fas', 'angle-up']} sx={{ fontSize: "1.265rem !important" }} data-hf="accordion-icon" />
                      </Button>
                    </Box>
                  </Box>
                </div>
                <Collapse in={accordion[16]}>
                  <div style={{ padding: "1.5rem" }}>
                    <Container>
                      <Grid
                        container
                        direction="column"
                        spacing={2}
                        sx={{
                          justifyContent: "center"
                        }}
                      >
                        {map(MoreDetailFilters, (filter) =>
                          renderFilters(filter),
                        )}
                      </Grid>
                    </Container>
                  </div>
                </Collapse>
              </Card>
            </Card>
          )}
        <Grid
          container
          direction="row"
          spacing={1}
          style={{ padding: 20 }}
          sx={{
            justifyContent: "center",
            alignItems: "center"
          }}>
          {!props.lot && !props.propertySearch && !props.comps && (
            <Grid size={12} key="save">
              <Button
                variant="contained"
                size="small"
                color="secondary"
                fullWidth={true}
                onClick={toggleModal}
                disabled={!hasChanged}
              >
                <FontAwesomeIcon icon={['far', 'floppy-disk']} style={{ marginRight: 10 }} sx={{ fontSize: "1.15rem !important" }} />
                <Typography>Save Filter</Typography>
              </Button>
            </Grid>
          )}
          <Grid size={12} key="clear">
            <Button
              variant="contained"
              size="small"
              onClick={reset}
              fullWidth={true}
            >
              <FontAwesomeIcon icon={['fas', 'xmark']} style={{ marginRight: 10 }} sx={{ fontSize: "1.15rem !important" }} />
              <Typography>Clear Filters</Typography>
            </Button>
          </Grid>
          <Grid size={12} key="see">
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={props.toggleDrawer}
              fullWidth={true}
            >
              {/* <FontAwesomeIcon
                icon={['fas', 'xmark']}
                style={{ marginRight: 10 }}
              /> */}
              <Typography>See Filtered Properties</Typography>
            </Button>
          </Grid>
          {activeName &&
            !props.lot &&
            !props.propertySearch &&
            !props.comps && (
              <Grid size={12} key="delete">
                <Button
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  onClick={toggleModal1}
                  disabled={!activeName}
                >
                  <Typography>Delete Saved Filter</Typography>
                </Button>
              </Grid>
            )}
        </Grid>

        {/* Save Filter Dialog */}
        <Dialog
          open={show}
          onClose={toggleModal}
          slotProps={{ paper: { sx: [{ boxShadow: "0 1rem 3rem rgba(7, 9, 25, 0.575) !important" }, { borderRadius: "0.65rem !important" }] } }}
          maxWidth="xs"
          fullWidth={true}
        >
          <DialogTitle>Save Filter</DialogTitle>
          <ValidatorForm
            style={{
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column'}}
            onSubmit={(event) => onSubmit(event, filters)}
          >
            <DialogContent>
              <Grid
                container
                direction="row"
                spacing={1}
                sx={{
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                <Grid size={12} key="name">
                  <TextValidator
                    variant="outlined"
                    margin="dense"
                    label="Filter Name"
                    autoFocus
                    fullWidth={true}
                    value={name}
                    onChange={(event) =>
                      setName(event.target.value)
                    }
                    required={true}
                    validators={[
                      'required',
                      'maxStringLength: 20',
                    ]}
                    errorMessages={[
                      'This field is required',
                      'You cannot exceed 20 characters',
                    ]}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                onClick={() => {
                  reset()
                  toggleModal()
                }}
              >
                <FontAwesomeIcon icon={['fas', 'xmark']} style={{ marginRight: 10 }} sx={{ fontSize: "1.15rem !important" }} />
                <Typography>Clear Filters</Typography>
              </Button>
              <Typography style={{ flex: 1 }} />
              <Button variant="text" onClick={toggleModal}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ marginRight: 10 }}
              >
                Save
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>

        {/* Delete Saved Filter Dialog */}
        <Dialog
          open={show1}
          onClose={toggleModal1}
          slotProps={{ paper: { sx: [{ boxShadow: "0 1rem 3rem rgba(7, 9, 25, 0.575) !important" }, { borderRadius: "0.65rem !important" }] } }}
          maxWidth="xs"
          fullWidth={true}
        >
          <Card>
            <CardHeader title="Delete Filter" />
            <Divider />
            <CardContent>
              <Grid
                container
                direction="row"
                spacing={1}
                sx={{
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                <Grid size={12} key="delete">
                  <div style={{ textAlign: "center", padding: "3rem" }}>
                    <Box style={{ margin: 0 }} sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mr: "0.25rem",
                      position: "relative",
                      fontSize: "1.2rem",
                      transition: "all 0.2s ease-in-out",
                      "&:last-child": { mr: 0, marginRight: 0 },
                      "& .badge": { position: "absolute", right: 0, bottom: 0 },
                      "& svg, & .svg-inline--fa": { display: "block" },
                      marginRight: "0.25rem",
                      borderRadius: "50% !important",
                    }}>
                      <Box style={{ display: "inline-flex", justifyContent: "center", padding: 0, alignItems: "center", border: 0, backgroundColor: "#ffe6ea", color: "#f83245", margin: 0, height: 130, width: 130, lineHeight: "130px" }} sx={{
                        borderRadius: "50% !important",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mr: "0.25rem",
                        position: "relative",
                        fontSize: "1.2rem",
                        transition: "all 0.2s ease-in-out",
                        "&:last-child": { mr: 0, marginRight: 0 },
                        "& .badge": { position: "absolute", right: 0, bottom: 0 },
                        "& svg, & .svg-inline--fa": { display: "block" },
                        marginRight: "0.25rem",
                      }}>
                        <FontAwesomeIcon icon={['fas', 'xmark']} sx={[[{ display: "flex" }, { alignSelf: "center" }], { fontSize: "2.5rem", fontWeight: "300", lineHeight: "1.2" }]} />
                      </Box>
                    </Box>
                    <h4 style={{ fontWeight: 700, marginTop: "1.5rem" }}>
                      Are you sure you want to delete this?
                    </h4>
                    <Box component="p" style={{ marginBottom: 0, color: "#a6a6b9" }} sx={{ fontSize: "1.15rem !important" }}>
                      All data will be deleted. This action cannot be
                      undone.
                    </Box>
                    <div style={{ paddingTop: "1.5rem" }}>
                      <Button
                        variant="text"
                        onClick={toggleModal1}
                      >
                        <Box component="span" sx={{
                          display: "inline-block",
                          "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                          "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                        }}>
                          Cancel
                        </Box>
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: '#f83145',
                          color: 'white'}}
                        onClick={() =>
                          deleteFilter(activeName, filters)
                        }
                      >
                        <Box component="span" sx={{
                          display: "inline-block",
                          "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                          "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                        }}>
                          Delete
                        </Box>
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Dialog>
      </Box>
    </>
  );
}

export default withSession(PropertiesFilterComponent)
